import SectionTitle from '../../components/Common/SectionTitle';
import SingleServiceTwo from '../../components/Service/SingleServiceTwo';

// Service Image Icons
import mainIcon1 from '../../assets/img/service/style2/main-img/1.png';
import hoverIcon1 from '../../assets/img/service/style2/hover-img/1.png';
import mainIcon2 from '../../assets/img/service/style2/main-img/2.png';
import hoverIcon2 from '../../assets/img/service/style2/hover-img/2.png';
import mainIcon3 from '../../assets/img/service/style2/main-img/3.png';
import hoverIcon3 from '../../assets/img/service/style2/hover-img/3.png';
import mainIcon4 from '../../assets/img/service/style2/main-img/4.png';
import hoverIcon4 from '../../assets/img/service/style2/hover-img/4.png';
import mainIcon5 from '../../assets/img/service/style2/main-img/5.png';
import hoverIcon5 from '../../assets/img/service/style2/hover-img/5.png';
import mainIcon6 from '../../assets/img/service/style2/main-img/6.png';
import hoverIcon6 from '../../assets/img/service/style2/hover-img/6.png';

const Service = () => {

    return (
        <div id="rs-service" className="rs-services style3 pt-110 pb-100 md-pt-74 md-pb-60">
            <div className="container">
                <SectionTitle
                    sectionClass="sec-title2 text-center mb-44"
                    subtitleClass="sub-text"
                    subtitle="Services"
                    titleClass="title testi-title"
                    title="Our Featured Services"
                />
                <div className="row">
                    <div className="col-lg-4 col-md-6 mb-20">
                        <SingleServiceTwo
                            itemClass="services-item"
                            prefix="01"
                            mainIcon={mainIcon1}
                            hoverIcon={hoverIcon1}
                            Title="Software Development"
                            // serviceURL="software-development"
                            Text="We offer software consulting services to help you develop solutions that meet your specific needs. We assess your current software infrastructure, identify areas for improvement, and develop a clear roadmap for future development. Our team has expertise across various industries and provides guidance on best practices, industry standards, and emerging technologies."
                        />
                    </div>
                    <div className="col-lg-4 col-md-6 mb-20">
                        <SingleServiceTwo
                            itemClass="services-item pink-bg"
                            prefix="02"
                            mainIcon={mainIcon2}
                            hoverIcon={hoverIcon2}
                            Title="Web Development"
                            // serviceURL="web-development"
                            Text="We design and develop custom web applications, websites, and e-commerce platforms tailored to your specific needs. Our team uses the latest technologies and frameworks to create high-performance, scalable, and secure web solutions that meet industry standards."
                        />
                    </div>
                    <div className="col-lg-4 col-md-6 mb-20">
                        <SingleServiceTwo
                            itemClass="services-item aqua-bg"
                            prefix="03"
                            mainIcon={mainIcon3}
                            hoverIcon={hoverIcon3}
                            Title="Analytic Solutions"
                            // serviceURL="analytic-solutions"
                            Text="We help you gain meaningful insights from your data and make confident, data-driven decisions. Our services include data analytics consulting, data visualisation, and data warehousing — plus predictive models that help you stay ahead."
                        />
                    </div>
                    <div className="col-lg-4 col-md-6 mb-20">
                        <SingleServiceTwo
                            itemClass="services-item paste-bg"
                            prefix="04"
                            mainIcon={mainIcon4}
                            hoverIcon={hoverIcon4}
                            Title="Cloud & DevOps"
                            // serviceURL="cloud-devops"
                            Text="We help you optimise your cloud infrastructure and implement DevOps practices that improve your development processes. From cloud consulting and migration to infrastructure management, we streamline collaboration and reduce time-to-market."
                        />
                    </div>
                    <div className="col-lg-4 col-md-6 mb-20">
                        <SingleServiceTwo
                            itemClass="services-item purple-bg"
                            prefix="05"
                            mainIcon={mainIcon5}
                            hoverIcon={hoverIcon5}
                            Title="MVP Development"
                            // serviceURL="product-&-design"
                            Text="We help you get your idea to market quickly and cost-effectively with a Minimum Viable Product. Using agile development methodologies, we validate your concept, gather real customer feedback, and deliver on time and within budget."
                        />
                    </div>
                    <div className="col-lg-4 col-md-6 mb-20">
                        <SingleServiceTwo
                            itemClass="services-item green-bg"
                            prefix="06"
                            mainIcon={mainIcon6}
                            hoverIcon={hoverIcon6}
                            Title="Report Automation Solutions"
                            // serviceURL="database-administrator"
                            Text="Manual reporting is time-consuming and error-prone. We build custom report automation solutions tailored to your needs — so you can generate reports faster, reduce mistakes, and trust the accuracy of your data."
                        />
                    </div>
                    <div className="col-lg-4 col-md-6 mb-20">
                        <SingleServiceTwo
                            itemClass="services-item"
                            prefix="07"
                            mainIcon={mainIcon1}
                            hoverIcon={hoverIcon1}
                            Title="AI Workflow Automation"
                            Text="We identify where AI can make the biggest impact and implement automation that works — from intelligent chatbots to end-to-end workflow pipelines using n8n, Make, and Zapier. We deliver practical automation that pays for itself."
                        />
                    </div>
                    <div className="col-lg-4 col-md-6 mb-20">
                        <SingleServiceTwo
                            itemClass="services-item pink-bg"
                            prefix="08"
                            mainIcon={mainIcon2}
                            hoverIcon={hoverIcon2}
                            Title="AI Consulting &amp; Strategy"
                            Text="Not sure where to start with AI? We offer AI Workflow Audits and strategic roadmaps to help your business adopt AI — without the enterprise price tag. Book a free AI Workflow Audit to find out where you're leaving time and money on the table."
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Service;